import React, {useState, useContext, useEffect} from "react";
import {Box, Button, Icon, IconButton, Tooltip} from '@material-ui/core';
import SystemContext from "../SystemContext";
import __ from "lodash";

const ActionsBar = (props) => {
  const {actions, record, validationState, eventPrefix, recordChange} = props;
  const [actionStates, setActionStates] = useState({});

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  useEffect(()=> {
    const handleChangeActionState = (changes) => {
      setActionStates({...actionStates, ...changes});
    }
    eventBus.bind(`${eventPrefix}.changeActionState`, handleChangeActionState);

    return ()=> {
      eventBus.unbind(`${eventPrefix}.changeActionState`, handleChangeActionState);
    }
  },[actionStates, eventBus, eventPrefix]);

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      p: 1,
      m: 1,
      bgcolor: 'background.paper',
      borderRadius: 1,
      padding: 0,
      margin: 0,
      ...props.boxProps
    }}>
      {Object.entries(actions).map(([key, actionProps]) => {
        const action = __.omit(actionProps,['label', 'icon', 'iconOptions', 'onClick', 'disabled', 'hidden', 'startIcon', 'tooltip', 'eventName']);
        const iconOptions = {color:"primary", ...props.iconOptions};
        const buttonState = {
          disabled: false,
          hidden: false,
          ...actionStates[key]
        }

        if (typeof actionProps.onClick === "function") {
          action['onClick'] = actionProps.onClick({record, recordChange, buttonState});
        } else {
          action['onClick'] = () => {eventBus.trigger(actionProps.eventName?`${actionProps.eventName}`:`${eventPrefix}.actionClicked`, {action, record, recordChange, buttonState});}
        };
        if (typeof actionProps.hidden === "function") {
          action['hidden'] = actionProps.hidden({record, error:validationState?.error, errorMessage:validationState?.errorMessage, buttonState});
        } else {
          action['hidden'] = actionProps.hidden || buttonState.hidden;
        }
        if (typeof actionProps.disabled === "function") {
          action['disabled'] = actionProps.disabled({record, error:validationState?.error, errorMessage:validationState?.errorMessage, buttonState});
        } else {
          action['disabled'] = actionProps.disabled || buttonState.disabled;
        }
        if (typeof actionProps.tooltip === "function") {
          action['tooltip'] = actionProps.tooltip({record, buttonState});
        }
        iconOptions['hidden'] = action.hidden;
        iconOptions['disabled'] = action.disabled;
        if (iconOptions.disabled) {
          iconOptions['color']=undefined;
        }

        if (action.type === 'button') {
          if (actionProps.icon) {
            action['startIcon'] = (<Icon {...iconOptions}>{actionProps.icon}</Icon>);
          }
          if (typeof actionProps.tooltip === "string") {
            return (
              <Tooltip title={actionProps.tooltip}>
                <Button {...action}>
                  {actionProps.label}
                </Button>
              </Tooltip>
            )    
          }
          return (
            <Button {...action}>
              {actionProps.label}
            </Button>
          )  
        } else {
          if (typeof actionProps.tooltip === "string") {
            return (
              <IconButton {...action}>
                <Tooltip title={actionProps.tooltip}>
                  <Icon {...iconOptions}>{actionProps.icon}</Icon>
                </Tooltip>
              </IconButton>
            )    
          }
          return (
            <IconButton {...action}>
              <Icon {...iconOptions}>{actionProps.icon}</Icon>
            </IconButton>
          )            
        }
      })}
    </Box>
  )
}

export default ActionsBar;